<template>
  <div class="fill-height">
    <v-content class="fill-height">
      <v-container fluid>
        <Loader v-if="loading"/>
        <v-card v-else rounded>
          <PageBar :title="title" :back="true"/>
          <div v-for="(video, index) in media"
               :key="'video'+index"
               style="margin-bottom: 20px"
          >
            <vue-plyr style="width: 100%" :options="options">
              <video :src="video.src">
                <source :src="`https://hb.bizmrg.com/impel_media/help/${video.s3name}`" type="video/mp4">
              </video>
            </vue-plyr>
          </div>
          <editor v-if="!loading" ref="editor" :config="config" :initialized="onInitialized"/>
        </v-card>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import Paragraph from "@editorjs/paragraph";
import ImageTool from "@editorjs/image";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import CodeTool from "@editorjs/code";
import Embed from "@editorjs/embed";
import Table from "@editorjs/table";
import Marker from "@editorjs/marker";
import Delimiter from "@editorjs/delimiter";
import VuePlyr from 'vue-plyr'
export default {
  name: 'HelpDetail',
  components: {
    PageBar: () => import('@/components/bar/Page.vue'),
    Loader: () => import('@/components/placeholder/Loader'),
    VuePlyr
  },
  data: () => ({
    title: "Статья",
    loading: true,
    post: {},
    content: {},
    config: {
      tools: {
        paragraph: {
          class: Paragraph,
        },
        image: {
          class: ImageTool,
          config: {
            endpoints: {
              byFile: ''
            },
            additionalRequestHeaders: {
              Authorization: ''
            }
          },
          field: 'image',
          types: 'image/*',
        },
        header: {
          class: Header,
          config: {
            placeholder: 'Введите заголовок',
            levels: [2, 3, 4],
            defaultLevel: 3,
          }
        },
        list: {
          class: List,
          inlineToolbar: true,
        },
        code: {
          class: CodeTool
        },
        embed: {
          class: Embed,
          config: {
            services: {
              youtube: true,
              coub: true,
              imgur: true
            }
          }
        },
        table: {
          class: Table,
          inlineToolbar: true,
          config: {
            rows: 1,
            cols: 2,
          },
        },
        Marker: {
          class: Marker,
          shortcut: 'CMD+SHIFT+M',
        },
        delimiter: Delimiter,
      },
      onReady: () => {
        console.log('on ready');
        var elements = document.querySelectorAll('[contenteditable=true]')
        elements.forEach(element => {
          element.setAttribute('contenteditable' , false);
        });
      },
      onChange: () => {
        console.log('change');
        self.test();
      },
      data: {

      }
    },
    editor: {},
    media: []
  }),
  methods: {
    onInitialized (editor) {
      console.log(editor);
      this.editor = editor;
    },
    getPost() {
      this.loading = true;
      this.$http.get(`${this.$serverApiLink}help/detail/${this.$route.params.id}`).then(
          response => {
            //window.console.log(JSON.parse(response.data.data.json));
            this.title = response.data.data.name;
            this.config.data = JSON.parse(response.data.data.json);
            this.media = response.data.data.media;
            this.loading = false;
          }
      ).catch(
          error => {
            this.$store.commit('setSnack', {
              status: true,
              code: error.response.status,
              message: error.response.data.message,
              type: 'error'
            });
            window.console.log(error.response)
            this.loading = false;
          }
      );
    },
  },
  mounted() {
    this.getPost();
  }
}
</script>

<style>
/*
.cdx-block {
    background: #1E1E1E;
}

 */
.theme--dark .codex-editor {
  background: #272736;
}
.theme--light .codex-editor {
  background: #ffffff;
}
.codex-editor {
  padding: 30px;
}
.ce-block__content, .ce-toolbar__content {
  max-width: 100%!important;
}
#codex-editor .ce-toolbar__plus{
  display: none;
}

#codex-editor .ce-toolbar{
  display:none;
}
textarea {
  pointer-events: none;
}
.cdx-checklist__item-checkbox {
  pointer-events: none;
}
.tc-toolbar--ver {
  display:none!important;
}
.tc-toolbar--hor {
  display:none!important;
  pointer-events: none;
}
.codex-editor__redactor {
  padding-bottom: 0!important;
}
.ce-toolbar__actions--opened {
  display: none!important;
}
.plyr__control--overlaid {
  background: #a04e4e!important;
}
</style>